/**
 * PostHog event names and property names for feedback feature.
 * Use these constants to avoid scattering string literals (per posthog-integration rule).
 */

export const FEEDBACK_EVENTS = {
  FORM_VIEWED: 'feedback_form_viewed',
  FORM_SUBMITTED: 'feedback_form_submitted',
} as const;

export type FeedbackEventName =
  (typeof FEEDBACK_EVENTS)[keyof typeof FEEDBACK_EVENTS];

/** Property names for feedback_form_submitted event (for PostHog dashboard/filters). */
export const FEEDBACK_FORM_SUBMITTED_PROPERTIES = {
  RATING_OVERALL: 'rating_overall',
  RATING_SETTINGS: 'rating_settings',
  RATING_TRANSLATION: 'rating_translation',
  RATING_SAVE_PROGRESS: 'rating_save_progress',
  RATING_RECALC_FEATURE: 'rating_recalc_feature',
  RATING_READ_MORE: 'rating_read_more',
  FEEDBACK_DIFFICULT: 'feedback_difficult',
  FEEDBACK_FEATURES: 'feedback_features',
  SOURCE: 'source',
} as const;

/** Max length for text properties sent to PostHog to keep event size reasonable. */
export const FEEDBACK_POSTHOG_TEXT_MAX_LENGTH = 500;
